module.exports = __webpack_public_path__ + "static/media/loading.31fdeac4.svg";